import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { useDispatch } from "react-redux";

const EXPONENT_EMISSION_CAMPAIGNS_TAG = "ExponentEmissionCampaigns";

export type ScheduledTokenEmissionCampaign = {
    id: string;
    destinationTokenAccount: string;
    destinationOwner: string;
    emissionMint: string;
    emissionDecimals: number;
    emissionRateRawPerSecond: string;
    sendFrequencySeconds: number;
    treasuryTokenAccount: string;
    tokenProgramId: string;
    awsKmsKeyId: string | null;
    isActive: boolean;
    startsAt: string;
    endsAt: string;
    fundingAmountRaw: string;
    initialFundingTxSignature: string | null;
    createdByAdminAddress: string;
    lastModifiedByAdminAddress: string;
    reservedRaw: string;
    submittedRaw: string;
    confirmedRaw: string;
    failedRaw: string;
    undistributedRaw: string;
    sendCount: number;
    lastReservedIntervalEnd: string | null;
    campaignStatus: "scheduled" | "active" | "paused" | "completed" | "funding_exhausted";
    createdAt: string;
    updatedAt: string;
};

type ScheduledTokenEmissionCampaignsResponse = {
    campaigns: ScheduledTokenEmissionCampaign[];
};

export const exponentExternalApi = createApi({
    reducerPath: "exponentExternalApi",
    tagTypes: [EXPONENT_EMISSION_CAMPAIGNS_TAG],
    baseQuery: fetchBaseQuery({ baseUrl: "https://api.exponent.finance/" }),
    endpoints: (builder) => ({
        scheduledTokenEmissionCampaigns: builder.query<ScheduledTokenEmissionCampaign[], void>({
            providesTags: [EXPONENT_EMISSION_CAMPAIGNS_TAG],
            query: () => ({
                url: "/scheduled-token-emissions/campaigns",
                method: "GET"
            }),
            transformResponse: (response: ScheduledTokenEmissionCampaignsResponse) => response.campaigns
        })
    })
});

export const { useScheduledTokenEmissionCampaignsQuery } = exponentExternalApi;

export function useExponentExternalApi() {
    const dispatch = useDispatch();
    return {
        resetExponentExternalApi: () =>
            dispatch(exponentExternalApi.util.invalidateTags([EXPONENT_EMISSION_CAMPAIGNS_TAG]))
    };
}
